
<div class="tsd_container">
  <mat-card-content style="text-align: end;">
    <mat-hint style="color: red;">{{showStatus}} </mat-hint>
    @if (showDeactivateToggle && id.value) {
      <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked">Deactivate</mat-slide-toggle>
    }
    @if (showReactivateToggle && id.value) {
      <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked">Reactivate</mat-slide-toggle>
    }
  </mat-card-content>
  <form [formGroup]="businessSegmentForm">
    <mat-card>
      <mat-card-content>
        <mat-form-field class="mat-width">
          <mat-label>Business Segment Name</mat-label>
          <input matInput placeholder="Business Segment Name" formControlName="name" autocomplete="off" required>
          @if (name.touched && name.invalid && name.hasError('required')) {
            <mat-error>Business Segment Name is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mat-width">
          <mat-label>Business Segment Code</mat-label>
          <input matInput placeholder="Business Segment Code" formControlName="code" autocomplete="off" required>
          @if (name.touched && name.invalid && name.hasError('required')) {
            <mat-error>Business Segment Code is required</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
        <button mat-button color="primary" (click)="save()" [disabled]="disableSubmit || !editPermission">SAVE</button>
      </mat-card-actions>
      <mat-card-content style="margin-top: 3%;">
        @if (id.value) {
          <div class="audit-log">
            <button mat-stroked-button type="button" [class.active]="viewLog.value"
                (click)="viewLog.setValue(!viewLog.value)">
                <mat-icon>history</mat-icon> View Log
            </button>
          </div>
        }
        @if (viewLog.value) {
          <app-history [referenceType]="'BUSINESS_SEGMENT'" [referenceId]="id.value"></app-history>
        }
      </mat-card-content>
    </mat-card>
  </form>
</div>
